import { faCircleInfo } from "@fortawesome/free-solid-svg-icons/faCircleInfo";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import styled from "styled-components";

const StyledFontAwesomeIcon = styled(FontAwesomeIcon)`
  color: #2367b2;
`;

export const InfoCircle = () => {
  return <StyledFontAwesomeIcon icon={faCircleInfo} />;
};
